import { AxiosResponse } from "axios";
import SubstrateSample from "../models/substrate/SubstrateSample";
import SubstrateAttachment from "../models/substrate/SubstrateAttachment";
import Api from "./Api";
import ApiResponse from "../models/ApiResponse";
import SubstrateSampleDTO from "../models/substrate/SubstrateSampleDTO";

class SubstrateSamplesApi {
  constructor(private api: Api) {}

  public addAttachment(
    testRequestId: string,
    substrateSampleId: number,
    ids: string[],
    type: string,
  ): Promise<SubstrateAttachment[]> {
    return this.api
      .put(`/test-request/v2/testrequests/${testRequestId}/substrates/${substrateSampleId}/attachments/${type}`, ids)
      .then((response) => SubstrateSamplesApi.readAttachments(substrateSampleId, response));
  }

  public createSubstrateSampleInformation(payload: SubstrateSample): Promise<AxiosResponse<SubstrateSample>> {
    return this.api.post("/test-request/substrate-samples", payload);
  }

  public fetchSubstrateSampleById(testRequestId: string, substrateSampleId: number): ApiResponse<SubstrateSampleDTO> {
    return this.api.get(`test-request/v2/testrequests/${testRequestId}/substrates/${substrateSampleId}`);
  }

  public getSelectedSubstrateSamples(testRequestId: string): Promise<SubstrateSample[]> {
    return this.api
      .get(`/test-request/v2/testrequests/${testRequestId}/substrates`)
      .then((response: AxiosResponse<SubstrateSample[]>) => response.data);
  }

  public updateSubstrateSampleInformation(
    testRequestId: string,
    substrateSampleId: number,
    payload: SubstrateSample,
  ): Promise<AxiosResponse<SubstrateSample>> {
    return this.api.put(`/test-request/v2/testrequests/${testRequestId}/substrates/${substrateSampleId}`, payload);
  }

  public removeAttachment(
    testRequestId: string,
    substrateSampleId: number,
    ids: string[],
  ): Promise<SubstrateAttachment[]> {
    return this.api
      .delete(`/test-request/v2/testrequests/${testRequestId}/substrates/${substrateSampleId}/attachments`, ids)
      .then((response) => SubstrateSamplesApi.readAttachments(substrateSampleId, response));
  }

  public static readAttachments(
    substrateSampleId: number,
    response: AxiosResponse<{
      substrateSampleReferences: {
        substrateSampleId: number;
        substrateSampleAttachments: SubstrateAttachment[];
      }[];
    }>,
  ): SubstrateAttachment[] {
    return response.data.substrateSampleReferences
      .filter((s) => s.substrateSampleId === substrateSampleId)
      .flatMap((s) => s.substrateSampleAttachments);
  }
}

export default SubstrateSamplesApi;
